import { createAction, createRequestTypes, FAILURE, REQUEST, RESET, SUCCESS } from '../../../utils/actionGenerator';

export const GET_CONSIGNMENT_STATES = createRequestTypes('GET_CONSIGNMENT_STATES');
export const GET_CONSIGNMENTS = createRequestTypes('GET_CONSIGNMENTS');
export const GET_SUPPLY_DETAILS = createRequestTypes('GET_SUPPLY_DETAILS');
export const GET_BASIC_DETAILS = createRequestTypes('GET_BASIC_DETAILS');
export const GET_OPERATOR_BY_PHONE = createRequestTypes('GET_OPERATOR_BY_PHONE');
export const UPDATE_BASIC_DETAIL = createRequestTypes('UPDATE_BASIC_DETAIL');
export const EDIT_VEHICLE_DETAILS = createRequestTypes('EDIT_VEHICLE_DETAILS');
export const EDIT_DRIVER_DETAILS = createRequestTypes('EDIT_DRIVER_DETAILS');
export const EDIT_INVOICE_DETAILS = createRequestTypes('EDIT_INVOICE_DETAILS');
export const CREATE_TRANSACTION = createRequestTypes('CREATE_TRANSACTION');
export const GET_DEMAND_DETAILS = createRequestTypes('GET_DEMAND_DETAILS');
export const GET_THIRD_PARTY_DETAILS = createRequestTypes('GET_THIRD_PARTY_DETAILS');
export const GET_DEMAND_CONFIG = createRequestTypes('GET_DEMAND_CONFIG');
export const GET_RC_CONFIG = createRequestTypes('GET_RC_CONFIG');
export const UPDATE_DEMAND_DETAILS = createRequestTypes('UPDATE_DEMAND_DETAILS');
export const GET_ACTIVITY_DETAILS = createRequestTypes('GET_ACTIVITY_DETAILS');
export const GET_COMMENT_CATEGORIES = createRequestTypes('GET_COMMENT_CATEGORIES');
export const POST_COMMENT = createRequestTypes('POST_COMMENT');
export const UPDATE_FREIGHT_DETAILS = createRequestTypes('UPDATE_FREIGHT_DETAILS');
export const GET_BANK_DETAILS = createRequestTypes('GET_BANK_DETAILS');
export const EDIT_TRANSACTION = createRequestTypes('EDIT_TRANSACTION');
export const EMPTY_BANK_DETAILS = createRequestTypes('EMPTY_BANK_DETAILS');
export const GET_DOCKETS = createRequestTypes('GET_DOCKETS');
export const SETTLE_OPERATOR = createRequestTypes('SETTLE_OPERATOR');
export const ADD_EXPENSE = createRequestTypes('ADD_EXPENSE');
export const EDIT_EXPENSE = createRequestTypes('EDIT_EXPENSE');
export const GET_RC_URL = createRequestTypes('GET_RC_URL');
export const GET_RELATION_DOC_URL = createRequestTypes('GET_RELATION_DOC_URL');
export const CLEAR_RELATION_DOC_NAMES = createRequestTypes('CLEAR_RELATION_DOC_NAMES');
export const GET_INVOICE_DOC_URL = createRequestTypes('GET_INVOICE_DOC_URL');
export const CLEAR_INVOICE_DOC_NAME = createRequestTypes('CLEAR_INVOICE_DOC_NAME');
export const GET_INSURANCE_DOC_URL = createRequestTypes('GET_INSURANCE_DOC_URL');
export const CLEAR_INSURANCE_DOC_NAME = createRequestTypes('CLEAR_INVOICE_DOC_NAME');
export const SAVE_RC_URL = createRequestTypes('SAVE_RC_URL');
export const SAVE_RC_DETAILS = createRequestTypes('SAVE_RC_DETAILS');
export const CREATE_DOCKET = createRequestTypes('CREATE_DOCKET');
export const SHARE_PAYMENT_LINK = createRequestTypes('SHARE_PAYMENT_LINK');
export const UPDATE_TIME = createRequestTypes('UPDATE_TIME');
export const GET_REMARKS = createRequestTypes('GET_REMARKS');
export const GET_TDS_INFO = createRequestTypes('GET_TDS_INFO');
export const EDIT_DOCKET = createRequestTypes('EDIT_DOCKET');
export const GET_CURRENT_DOCKET = createRequestTypes('GET_CURRENT_DOCKET');
export const CREATE_INVOICE = createRequestTypes('CREATE_INVOICE');
export const CLEAR_DOCKET = createRequestTypes('CLEAR_DOCKET');
export const DELETE_DOCKET = createRequestTypes('DELETE_DOCKET');
export const DELETE_INVOICE = createRequestTypes('DELETE_INVOICE');
export const GET_DOCKET_FILE_UPLOAD = createRequestTypes('GET_DOCKET_FILE_UPLOAD');
export const VIEW_FILES_DOCKET = createRequestTypes('VIEW_FILES_DOCKET');
export const GET_TRIP_DETAILS = createRequestTypes('GET_TRIP_DETAILS');
export const GET_ADDRESS_DETAILS = createRequestTypes('GET_ADDRESS_DETAILS');
export const GET_ADDRESS_DETAILS_OPERATIONV4 = createRequestTypes('GET_ADDRESS_DETAILS_OPERATIONV4');
export const EDIT_START_POINT = createRequestTypes('EDIT_START_POINT');
export const EDIT_END_POINT = createRequestTypes('EDIT_END_POINT');
export const GET_VIA_POINTS = createRequestTypes('GET_VIA_POINTS');
export const CREATE_VIA_POINT = createRequestTypes('CREATE_VIA_POINT');
export const GET_EXPENSE_TYPES = createRequestTypes('GET_EXPENSE_TYPES');
export const GET_EXPENSE_TYPES_V3 = createRequestTypes('GET_EXPENSE_TYPES_V3');
export const RESET_TABLE = createRequestTypes('RESET_TABLE');
export const GET_OPERATION_SEARCH = createRequestTypes('GET_OPERATION_SEARCH');
export const GET_CONSIGNER_CODES = createRequestTypes('GET_CONSIGNER_CODES');
export const CLEAR_FILES_DOCKET_VIEW = createRequestTypes('CLEAR_FILES_DOCKET_VIEW');
export const CLEAR_INVOICE_VIEW = createRequestTypes('CLEAR_INVOICE_VIEW');
export const CLEAR_INSURANCE_VIEW = createRequestTypes('CLEAR_INSURANCE_VIEW');
export const UPDATE_LOCATION = createRequestTypes('UPDATE_LOCATION');
export const UPDATE_VEHICLE_STATE = createRequestTypes('UPDATE_VEHICLE_STATE');
export const EDIT_VIA_POINT = createRequestTypes('EDIT_VIA_POINT');
export const UPLOAD_FREIGHT = createRequestTypes('UPLOAD_FREIGHT');
export const CLEAR_PHONE_OPERATOR = createRequestTypes('CLEAR_PHONE_OPERATOR');
export const CLEAR_FLAGS = createRequestTypes('CLEAR_FLAGS');
export const SAVE_FILTERS = createRequestTypes('SAVE_FILTERS');
export const SETTLE_SHIPPER = createRequestTypes('SETTLE_SHIPPER');
export const VIEW_FREIGHT = createRequestTypes('VIEW_FREIGHT');
export const CLEAR_FILES_DOCKET = createRequestTypes('CLEAR_FILES_DOCKET');
export const CLEAR_FREIGHT_NAME = createRequestTypes('CLEAR_FREIGHT_NAME');
export const CLEAR_RC_NAMES = createRequestTypes('CLEAR_RC_NAMES');
export const EDIT_INVOICE = createRequestTypes('EDIT_INVOICE');
export const EDIT_INSURANCE = createRequestTypes('EDIT_INSURANCE');
export const UPDATE_OPERATOR_FREIGHT_DETAILS = createRequestTypes('UPDATE_OPERATOR_FREIGHT_DETAILS');
export const UPDATE_TAB = createRequestTypes('UPDATE_TAB');
export const DELETE_EXPENSE = createRequestTypes('DELETE_EXPENSE');
export const VIEW_RC_RELATION_DOC_URL = createRequestTypes('VIEW_RC_RELATION_DOC_URL');
export const CLEAR_RC_RELATION_DOC_URL = createRequestTypes('CLEAR_RC_RELATION_DOC_URL');
export const SAVE_INVOICE_DETAILS = createRequestTypes('SAVE_INVOICE_DETAILS');
export const GET_INVOICES = createRequestTypes('GET_INVOICES');
export const VIEW_INVOICE = createRequestTypes('VIEW_INVOICE');
export const SAVE_INSURANCE_DETAILS = createRequestTypes('SAVE_INSURANCE_DETAILS');
export const GET_INSURANCE = createRequestTypes('GET_INSURANCE');
export const VIEW_INSURANCE = createRequestTypes('VIEW_INSURANCE');
export const SAVE_POD_STATUS = createRequestTypes('SAVE_POD_STATUS');
export const GET_EMAILS_LIST_OP = createRequestTypes('GET_EMAILS_LIST_OP');
export const GET_POD_DETAILS = createRequestTypes('GET_POD_DETAILS');
export const GET_POD_HISTORY = createRequestTypes('GET_POD_HISTORY');
export const GET_PHONE_NO = createRequestTypes('GET_PHONE_NO');
export const RESET_PHONE_NO = createRequestTypes('RESET_PHONE_NO');

export const SUBMIT_POD_DETAILS = createRequestTypes('SUBMIT_POD_DETAILS');
export const UPLOAD_POD_DOCUMENTS = createRequestTypes('UPLOAD_POD_DOCUMENTS');
// export const SUBMIT_POD_FILE_DETAILS = createRequestTypes('SUBMIT_POD_FILE_DETAILS');
export const VIEW_POD_DOCUMENT = createRequestTypes('VIEW_POD_DOCUMENT');
export const GET_POD_VALIDITY_REMARK = createRequestTypes('GET_POD_VALIDITY_REMARK');
export const RESET_POD_VALIDITY_REMARK = createRequestTypes('RESET_POD_VALIDITY_REMARK');
export const POST_CANCEL_TRIP = createRequestTypes('POST_CANCEL_TRIP');
export const FETCH_CANCEL_UNCANCEL_TRIP_REASONS = createRequestTypes('FETCH_CANCEL_UNCANCEL_TRIP_REASONS');
export const FETCH_STATES_FOR_DOCKET = createRequestTypes('FETCH_STATES_FOR_DOCKET');
export const SAVE_BASIC_DETAILS = createRequestTypes('SAVE_BASIC_DETAILS');
export const FETCH_TRIP_MAP_DETAILS = createRequestTypes('FETCH_TRIP_MAP_DETAILS');
export const GET_TRIP_ITINERARY = createRequestTypes('GET_TRIP_ITINERARY');
export const GET_DELAY_REASONS = createRequestTypes('GET_DELAY_REASONS');
export const GET_CANCEL_REASONS = createRequestTypes('GET_CANCEL_REASONS');
export const SAVE_DELAY_REASON = createRequestTypes('SAVE_DELAY_REASON');
export const SAVE_CANCEL_REASON = createRequestTypes('SAVE_CANCEL_REASON');
export const GET_EXTRA_EXPENSE_POLICY = createRequestTypes('GET_EXTRA_EXPENSE_POLICY');
export const GET_IMAGE_URL = createRequestTypes('GET_IMAGE_URL');
export const UPDATE_REFERENCE_ID = createRequestTypes('UPDATE_REFERENCE_ID');
export const UPDATE_STOPPAGE_REASON = createRequestTypes('UPDATE_STOPPAGE_REASON');

export const TRIGGER_CONSIGNER_FOR_BILTI = createRequestTypes('TRIGGER_CONSIGNER_FOR_BILTI');

export const GET_PAYMENT_BILLING_DATA = createRequestTypes('GET_PAYMENT_BILLING_DATA');
export const SUBMIT_PAYMENT_BILLING = createRequestTypes('SUBMIT_PAYMENT_BILLING');
export const SUBMIT_DOCKET_IMAGES = createRequestTypes('SUBMIT_DOCKET_IMAGES');
export const GET_IMAGE_PROOF_DOCKET_DETAILS = createRequestTypes('GET_IMAGE_PROOF_DOCKET_DETAILS');
export const SUBMIT_DELAY_MODAL = createRequestTypes('SUBMIT_DELAY_MODAL');
export const GET_DELAY_MODAL_DATA = createRequestTypes('GET_DELAY_MODAL_DATA');
export const RESET_GET_DELAY_MODAL_DATA = createRequestTypes('RESET_GET_DELAY_MODAL_DATA');
export const GENERATE_EWAY_BILL_NUMBER = createRequestTypes('GENERATE_EWAY_BILL_NUMBER');

export const getConsignmentStates = {
  request: () => createAction(GET_CONSIGNMENT_STATES[REQUEST]),
  success: (response) => createAction(GET_CONSIGNMENT_STATES[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNMENT_STATES[FAILURE], { response }),
  updateTab: (value) => createAction(UPDATE_TAB, { value }),
};

export const getConsignments = {
  request: (params, str) => createAction(GET_CONSIGNMENTS[REQUEST], { params, str }),
  success: (response, params) => createAction(GET_CONSIGNMENTS[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_CONSIGNMENTS[FAILURE], { response }),
};

export const getSupplyDetails = {
  request: (params) => createAction(GET_SUPPLY_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_SUPPLY_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_SUPPLY_DETAILS[FAILURE], { response }),
};

export const getOperationSearch = {
  request: (params) => createAction(GET_OPERATION_SEARCH[REQUEST], { params }),
  success: (response) => createAction(GET_OPERATION_SEARCH[SUCCESS], { response }),
  failure: (response) => createAction(GET_OPERATION_SEARCH[FAILURE], { response }),
};

export const getBasicDetails = {
  request: (consignmentId) => createAction(GET_BASIC_DETAILS[REQUEST], { consignmentId }),
  success: (response) => createAction(GET_BASIC_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_BASIC_DETAILS[FAILURE], { response }),
  resetTable: () => createAction(RESET_TABLE),
  saveFilters: (filter) => createAction(SAVE_FILTERS, { filter }),
};

export const getPaymentBillingData = {
  request: (demandId) => createAction(GET_PAYMENT_BILLING_DATA[REQUEST], { demandId }),
  success: (response) =>
    createAction(GET_PAYMENT_BILLING_DATA[SUCCESS], {
      response,
    }),
  failure: (response) =>
    createAction(GET_PAYMENT_BILLING_DATA[FAILURE], {
      response: { billingGST: '', gstNum: '', name: '', phone: '', paymentMode: '', reason: '' },
    }),
};

export const submitPaymentBilling = {
  request: (payload) => createAction(SUBMIT_PAYMENT_BILLING[REQUEST], payload),
  success: (response) => createAction(SUBMIT_PAYMENT_BILLING[SUCCESS], { response }),
  failure: (response) =>
    createAction(SUBMIT_PAYMENT_BILLING[FAILURE], {
      response: { response },
    }),
};

export const getEmailsList = {
  request: (params) => createAction(GET_EMAILS_LIST_OP[REQUEST], { params }),
  success: (response, params) => createAction(GET_EMAILS_LIST_OP[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_EMAILS_LIST_OP[FAILURE], { response }),
};

export const getPhoneNo = {
  request: (params) => createAction(GET_PHONE_NO[REQUEST], { params }),
  success: (response) => createAction(GET_PHONE_NO[SUCCESS], { response }),
  failure: (response) => createAction(GET_PHONE_NO[FAILURE], { response }),
  resetPhoneNo: () => createAction(RESET_PHONE_NO),
};

export const getOperatorByPhone = {
  request: (phone) => createAction(GET_OPERATOR_BY_PHONE[REQUEST], { phone }),
  success: (response) => createAction(GET_OPERATOR_BY_PHONE[SUCCESS], { response }),
  failure: (response) => createAction(GET_OPERATOR_BY_PHONE[FAILURE], { response }),
  clearPhoneOperator: () => createAction(CLEAR_PHONE_OPERATOR),
  clearFlags: () => createAction(CLEAR_FLAGS),
};

export const updateBasicDetail = {
  request: (payload) => createAction(UPDATE_BASIC_DETAIL[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_BASIC_DETAIL[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_BASIC_DETAIL[FAILURE], { response }),
};

export const editVehicleDetails = {
  request: (payload) => createAction(EDIT_VEHICLE_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(EDIT_VEHICLE_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_VEHICLE_DETAILS[FAILURE], { response }),
};

export const editDriverDetails = {
  request: (payload) => createAction(EDIT_DRIVER_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(EDIT_DRIVER_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_DRIVER_DETAILS[FAILURE], { response }),
};

export const editInvoiceDetails = {
  request: (payload) => createAction(EDIT_INVOICE_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(EDIT_INVOICE_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_INVOICE_DETAILS[FAILURE], { response }),
};

export const updateLocation = {
  request: (payload) => createAction(UPDATE_LOCATION[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_LOCATION[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_LOCATION[FAILURE], { response }),
};

export const updateStoppageReason = {
  request: (payload) => createAction(UPDATE_STOPPAGE_REASON[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_STOPPAGE_REASON[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_STOPPAGE_REASON[FAILURE], { response }),
};

export const getThirdPartyDetails = {
  request: (params) => createAction(GET_THIRD_PARTY_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_THIRD_PARTY_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_THIRD_PARTY_DETAILS[FAILURE], { response }),
};

export const createTransaction = {
  request: (payload) => createAction(CREATE_TRANSACTION[REQUEST], { payload }),
  success: (response) => createAction(CREATE_TRANSACTION[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_TRANSACTION[FAILURE], { response }),
};

export const deleteDocket = {
  request: (payload) => createAction(DELETE_DOCKET[REQUEST], { payload }),
  success: (response) => createAction(DELETE_DOCKET[SUCCESS], { response }),
  failure: (response) => createAction(DELETE_DOCKET[FAILURE], { response }),
};

export const deleteInvoice = {
  request: (payload) => createAction(DELETE_INVOICE[REQUEST], { payload }),
  success: (response) => createAction(DELETE_INVOICE[SUCCESS], { response }),
  failure: (response) => createAction(DELETE_INVOICE[FAILURE], { response }),
};

export const editTransaction = {
  request: (payload) => createAction(EDIT_TRANSACTION[REQUEST], { payload }),
  success: (response) => createAction(EDIT_TRANSACTION[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_TRANSACTION[FAILURE], { response }),
  emptyBankDetails: () => createAction(EMPTY_BANK_DETAILS),
};

export const getDemandDetails = {
  request: (params) => createAction(GET_DEMAND_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_DEMAND_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_DEMAND_DETAILS[FAILURE], { response }),
};

export const getDemandConfig = {
  request: () => createAction(GET_DEMAND_CONFIG[REQUEST]),
  success: (response) => createAction(GET_DEMAND_CONFIG[SUCCESS], { response }),
  failure: (response) => createAction(GET_DEMAND_CONFIG[FAILURE], { response }),
};

export const getRcConfig = {
  request: () => createAction(GET_RC_CONFIG[REQUEST]),
  success: (response) => createAction(GET_RC_CONFIG[SUCCESS], { response }),
  failure: (response) => createAction(GET_RC_CONFIG[FAILURE], { response }),
};

export const updateDemandDetails = {
  request: (payload) => createAction(UPDATE_DEMAND_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_DEMAND_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_DEMAND_DETAILS[FAILURE], { response }),
};

export const updateFreightDetails = {
  request: (payload) => createAction(UPDATE_FREIGHT_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_FREIGHT_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_FREIGHT_DETAILS[FAILURE], { response }),
};

export const updateOperatorFreightDetails = {
  request: (payload) => createAction(UPDATE_OPERATOR_FREIGHT_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_OPERATOR_FREIGHT_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_OPERATOR_FREIGHT_DETAILS[FAILURE], { response }),
};

export const getActivityDetails = {
  request: (params) => createAction(GET_ACTIVITY_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_ACTIVITY_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_ACTIVITY_DETAILS[FAILURE], { response }),
};

export const getCommentCategories = {
  request: (params) => createAction(GET_COMMENT_CATEGORIES[REQUEST], { params }),
  success: (response) => createAction(GET_COMMENT_CATEGORIES[SUCCESS], { response }),
  failure: (response) => createAction(GET_COMMENT_CATEGORIES[FAILURE], { response }),
};

export const postComment = {
  request: (payload) => createAction(POST_COMMENT[REQUEST], { payload }),
  success: (response) => createAction(POST_COMMENT[SUCCESS], { response }),
  failure: (response) => createAction(POST_COMMENT[FAILURE], { response }),
};

export const getBankDetails = {
  request: (params) => createAction(GET_BANK_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_BANK_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_BANK_DETAILS[FAILURE], { response }),
};

export const getDockets = {
  request: (params) => createAction(GET_DOCKETS[REQUEST], { params }),
  success: (response) => createAction(GET_DOCKETS[SUCCESS], { response }),
  failure: (response) => createAction(GET_DOCKETS[FAILURE], { response }),
};

export const getInvoices = {
  request: (params) => createAction(GET_INVOICES[REQUEST], { params }),
  success: (response) => createAction(GET_INVOICES[SUCCESS], { response }),
  failure: (response) => createAction(GET_INVOICES[FAILURE], { response }),
};

export const getInsurance = {
  request: (params) => createAction(GET_INSURANCE[REQUEST], { params }),
  success: (response) => createAction(GET_INSURANCE[SUCCESS], { response }),
  failure: (response) => createAction(GET_INSURANCE[FAILURE], { response }),
};

export const settleOperator = {
  request: (payload) => createAction(SETTLE_OPERATOR[REQUEST], { payload }),
  success: (response) => createAction(SETTLE_OPERATOR[SUCCESS], { response }),
  failure: (response) => createAction(SETTLE_OPERATOR[FAILURE], { response }),
};

export const saveBasicDetails = {
  request: (payload) => createAction(SAVE_BASIC_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(SAVE_BASIC_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(SAVE_BASIC_DETAILS[FAILURE], { response }),
};

export const settleShipper = {
  request: (payload) => createAction(SETTLE_SHIPPER[REQUEST], { payload }),
  success: (response) => createAction(SETTLE_SHIPPER[SUCCESS], { response }),
  failure: (response) => createAction(SETTLE_SHIPPER[FAILURE], { response }),
};

export const addExpense = {
  request: (payload) => createAction(ADD_EXPENSE[REQUEST], { payload }),
  success: (response) => createAction(ADD_EXPENSE[SUCCESS], { response }),
  failure: (response) => createAction(ADD_EXPENSE[FAILURE], { response }),
};

export const editExpense = {
  request: (payload) => createAction(EDIT_EXPENSE[REQUEST], { payload }),
  success: (response) => createAction(EDIT_EXPENSE[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_EXPENSE[FAILURE], { response }),
};

export const getRcUrl = {
  request: (payload) => createAction(GET_RC_URL[REQUEST], { payload }),
  success: (response, payload) => createAction(GET_RC_URL[SUCCESS], { response, payload }),
  failure: (response) => createAction(GET_RC_URL[FAILURE], { response }),
  clearRcNames: () => createAction(CLEAR_RC_NAMES),
};

export const getRelationDocUrl = {
  request: (payload) => createAction(GET_RELATION_DOC_URL[REQUEST], { payload }),
  success: (response, payload) => createAction(GET_RELATION_DOC_URL[SUCCESS], { response, payload }),
  failure: (response) => createAction(GET_RELATION_DOC_URL[FAILURE], { response }),
  clearRelationDocNames: () => createAction(CLEAR_RELATION_DOC_NAMES),
};

export const viewRcRelationDoc = {
  request: (params) => createAction(VIEW_RC_RELATION_DOC_URL[REQUEST], { params }),
  success: (response) => createAction(VIEW_RC_RELATION_DOC_URL[SUCCESS], { response }),
  failure: (response) => createAction(VIEW_RC_RELATION_DOC_URL[FAILURE], { response }),
  clearRcValidationDocView: () => createAction(CLEAR_RC_RELATION_DOC_URL),
};

export const getInvoiceDocUrl = {
  request: (payload) => createAction(GET_INVOICE_DOC_URL[REQUEST], { payload }),
  success: (response, payload) => createAction(GET_INVOICE_DOC_URL[SUCCESS], { response, payload }),
  failure: (response) => createAction(GET_INVOICE_DOC_URL[FAILURE], { response }),
  clearInvoiceDocName: () => createAction(CLEAR_INVOICE_DOC_NAME),
};

export const getInsuranceDocUrl = {
  request: (payload) => createAction(GET_INSURANCE_DOC_URL[REQUEST], { payload }),
  success: (response, payload) => createAction(GET_INSURANCE_DOC_URL[SUCCESS], { response, payload }),
  failure: (response) => createAction(GET_INSURANCE_DOC_URL[FAILURE], { response }),
  clearInsuranceDocName: () => createAction(CLEAR_INSURANCE_DOC_NAME),
};

export const saveRcUrl = {
  request: (payload) => createAction(SAVE_RC_URL[REQUEST], { payload }),
  success: (response, payload) => createAction(SAVE_RC_URL[SUCCESS], { response, payload }),
  failure: (response) => createAction(SAVE_RC_URL[FAILURE], { response }),
};

export const saveRcDetails = {
  request: (payload) => createAction(SAVE_RC_DETAILS[REQUEST], { payload }),
  success: (response, payload) => createAction(SAVE_RC_DETAILS[SUCCESS], { response, payload }),
  failure: (response) => createAction(SAVE_RC_DETAILS[FAILURE], { response }),
};

export const submitInvoice = {
  request: (payload) => createAction(SAVE_INVOICE_DETAILS[REQUEST], { payload }),
  success: (response, payload) => createAction(SAVE_INVOICE_DETAILS[SUCCESS], { response, payload }),
  failure: (response) => createAction(SAVE_INVOICE_DETAILS[FAILURE], { response }),
};

export const submitInsurance = {
  request: (payload) => createAction(SAVE_INSURANCE_DETAILS[REQUEST], { payload }),
  success: (response, payload) => createAction(SAVE_INSURANCE_DETAILS[SUCCESS], { response, payload }),
  failure: (response) => createAction(SAVE_INSURANCE_DETAILS[FAILURE], { response }),
};

export const createDocket = {
  request: (payload) => createAction(CREATE_DOCKET[REQUEST], { payload }),
  success: (response) => createAction(CREATE_DOCKET[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_DOCKET[FAILURE], { response }),
  clearDocket: () => createAction(CLEAR_DOCKET),
  clearFilesDocket: () => createAction(CLEAR_FILES_DOCKET),
  clearFilesDocketView: () => createAction(CLEAR_FILES_DOCKET_VIEW),
};

export const sharePaymentLink = {
  request: (payload) => createAction(SHARE_PAYMENT_LINK[REQUEST], { payload }),
  success: (response, payload) => createAction(SHARE_PAYMENT_LINK[SUCCESS], { response, payload }),
  failure: (response) => createAction(SHARE_PAYMENT_LINK[FAILURE], { response }),
};

export const updateTime = {
  request: (payload) => createAction(UPDATE_TIME[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_TIME[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_TIME[FAILURE], { response }),
};

export const editDocket = {
  request: (payload) => createAction(EDIT_DOCKET[REQUEST], { payload }),
  success: (response) => createAction(EDIT_DOCKET[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_DOCKET[FAILURE], { response }),
};

export const getCurrentDocket = {
  request: (docketId) => createAction(GET_CURRENT_DOCKET[REQUEST], { docketId }),
  success: (response) => createAction(GET_CURRENT_DOCKET[SUCCESS], { response }),
  failure: (response) => createAction(GET_CURRENT_DOCKET[FAILURE], { response }),
};

export const createInvoice = {
  request: (payload) => createAction(CREATE_INVOICE[REQUEST], { payload }),
  success: (response) => createAction(CREATE_INVOICE[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_INVOICE[FAILURE], { response }),
};

export const editInvoice = {
  request: (payload) => createAction(EDIT_INVOICE[REQUEST], { payload }),
  success: (response) => createAction(EDIT_INVOICE[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_INVOICE[FAILURE], { response }),
};

export const editInsurance = {
  request: (payload) => createAction(EDIT_INSURANCE[REQUEST], { payload }),
  success: (response) => createAction(EDIT_INSURANCE[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_INSURANCE[FAILURE], { response }),
};

export const getDocketFileUpload = {
  request: (payload) => createAction(GET_DOCKET_FILE_UPLOAD[REQUEST], { payload }),
  success: (response, payload) => createAction(GET_DOCKET_FILE_UPLOAD[SUCCESS], { response, payload }),
  failure: (response) => createAction(GET_DOCKET_FILE_UPLOAD[FAILURE], { response }),
};

export const viewFilesDocket = {
  request: (params) => createAction(VIEW_FILES_DOCKET[REQUEST], { params }),
  success: (response) => createAction(VIEW_FILES_DOCKET[SUCCESS], { response }),
  failure: (response) => createAction(VIEW_FILES_DOCKET[FAILURE], { response }),
};

export const viewInvoiceDoc = {
  request: (params) => createAction(VIEW_INVOICE[REQUEST], { params }),
  success: (response) => createAction(VIEW_INVOICE[SUCCESS], { response }),
  failure: (response) => createAction(VIEW_INVOICE[FAILURE], { response }),
  clearInvoiceView: () => createAction(CLEAR_INVOICE_VIEW),
};

export const viewInsuranceDoc = {
  request: (params) => createAction(VIEW_INSURANCE[REQUEST], { params }),
  success: (response) => createAction(VIEW_INSURANCE[SUCCESS], { response }),
  failure: (response) => createAction(VIEW_INSURANCE[FAILURE], { response }),
  clearInsuranceView: () => createAction(CLEAR_INSURANCE_VIEW),
};

export const uploadFreight = {
  request: (params) => createAction(UPLOAD_FREIGHT[REQUEST], { params }),
  success: (response) => createAction(UPLOAD_FREIGHT[SUCCESS], { response }),
  failure: (response) => createAction(UPLOAD_FREIGHT[FAILURE], { response }),
  clearFreightName: () => createAction(CLEAR_FREIGHT_NAME),
};

export const viewFreight = {
  request: (params) => createAction(VIEW_FREIGHT[REQUEST], { params }),
  success: (response) => createAction(VIEW_FREIGHT[SUCCESS], { response }),
  failure: (response) => createAction(VIEW_FREIGHT[FAILURE], { response }),
};

export const getTripDetails = {
  request: (params) => createAction(GET_TRIP_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_TRIP_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_TRIP_DETAILS[FAILURE], { response }),
};

export const getAddressDetails = {
  request: (params) => createAction(GET_ADDRESS_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_ADDRESS_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_ADDRESS_DETAILS[FAILURE], { response }),
};
export const getAddressDetailsOperationV4 = {
  request: (params) => createAction(GET_ADDRESS_DETAILS_OPERATIONV4[REQUEST], { params }),
  success: (response) => createAction(GET_ADDRESS_DETAILS_OPERATIONV4[SUCCESS], { response }),
  failure: (response) => createAction(GET_ADDRESS_DETAILS_OPERATIONV4[FAILURE], { response }),
};
export const editStartPoint = {
  request: (payload) => createAction(EDIT_START_POINT[REQUEST], { payload }),
  success: (response) => createAction(EDIT_START_POINT[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_START_POINT[FAILURE], { response }),
};

export const editEndPoint = {
  request: (payload) => createAction(EDIT_END_POINT[REQUEST], { payload }),
  success: (response) => createAction(EDIT_END_POINT[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_END_POINT[FAILURE], { response }),
};

export const getViaPoints = {
  request: (params) => createAction(GET_VIA_POINTS[REQUEST], { params }),
  success: (response) => createAction(GET_VIA_POINTS[SUCCESS], { response }),
  failure: (response) => createAction(GET_VIA_POINTS[FAILURE], { response }),
};

export const createViaPoint = {
  request: (payload) => createAction(CREATE_VIA_POINT[REQUEST], { payload }),
  success: (response) => createAction(CREATE_VIA_POINT[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_VIA_POINT[FAILURE], { response }),
};

export const editViaPoint = {
  request: (payload) => createAction(EDIT_VIA_POINT[REQUEST], { payload }),
  success: (response) => createAction(EDIT_VIA_POINT[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_VIA_POINT[FAILURE], { response }),
};

export const getExpenseTypes = {
  request: (params) => createAction(GET_EXPENSE_TYPES[REQUEST], { params }),
  success: (response) => createAction(GET_EXPENSE_TYPES[SUCCESS], { response }),
  failure: (response) => createAction(GET_EXPENSE_TYPES[FAILURE], { response }),
};

export const getExpenseTypesV3 = {
  request: (params) => createAction(GET_EXPENSE_TYPES_V3[REQUEST], { params }),
  success: (response) => createAction(GET_EXPENSE_TYPES_V3[SUCCESS], { response }),
  failure: (response) => createAction(GET_EXPENSE_TYPES_V3[FAILURE], { response }),
};

export const getRemarks = {
  request: (params) => createAction(GET_REMARKS[REQUEST], { params }),
  success: (response) => createAction(GET_REMARKS[SUCCESS], { response }),
  failure: (response) => createAction(GET_REMARKS[FAILURE], { response }),
};

export const getTdsInfo = {
  request: (params) => createAction(GET_TDS_INFO[REQUEST], { params }),
  success: (response) => createAction(GET_TDS_INFO[SUCCESS], { response }),
  failure: (response) => createAction(GET_TDS_INFO[FAILURE], { response }),
};

export const getConsignerCodes = {
  request: (payload) => createAction(GET_CONSIGNER_CODES[REQUEST], { payload }),
  success: (response) => createAction(GET_CONSIGNER_CODES[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNER_CODES[FAILURE], { response }),
};

export const updateVehicleState = {
  request: (payload) => createAction(UPDATE_VEHICLE_STATE[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_VEHICLE_STATE[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_VEHICLE_STATE[FAILURE], { response }),
};

export const deleteExpense = {
  request: (payload) => createAction(DELETE_EXPENSE[REQUEST], { payload }),
  success: (response) => createAction(DELETE_EXPENSE[SUCCESS], { response }),
  failure: (response) => createAction(DELETE_EXPENSE[FAILURE], { response }),
};

export const submitPodStatus = {
  request: (payload) => createAction(SAVE_POD_STATUS[REQUEST], { payload }),
  success: (response, payload) => createAction(SAVE_POD_STATUS[SUCCESS], { response, payload }),
  failure: (response) => createAction(SAVE_POD_STATUS[FAILURE], { response }),
};

export const getPodDetails = {
  request: (params) => createAction(GET_POD_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_POD_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_POD_DETAILS[FAILURE], { response }),
};

export const getPodHistory = {
  request: (params) => createAction(GET_POD_HISTORY[REQUEST], { params }),
  success: (response) => createAction(GET_POD_HISTORY[SUCCESS], { response }),
  failure: (response) => createAction(GET_POD_HISTORY[FAILURE], { response }),
};

export const submitPodDetails = {
  request: (payload) => createAction(SUBMIT_POD_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(SUBMIT_POD_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(SUBMIT_POD_DETAILS[FAILURE], { response }),
};

export const uploadPodDocument = {
  request: (payload) => createAction(UPLOAD_POD_DOCUMENTS[REQUEST], { payload }),
  success: (response) => createAction(UPLOAD_POD_DOCUMENTS[SUCCESS], { response }),
  failure: (response) => createAction(UPLOAD_POD_DOCUMENTS[FAILURE], { response }),
};

export const viewPodDocument = {
  request: (params) => createAction(VIEW_POD_DOCUMENT[REQUEST], { params }),
  success: (response) => createAction(VIEW_POD_DOCUMENT[SUCCESS], { response }),
  failure: (response) => createAction(VIEW_POD_DOCUMENT[FAILURE], { response }),
};

export const podValidityRemark = {
  request: (params) => createAction(GET_POD_VALIDITY_REMARK[REQUEST], { params }),
  success: (response) => createAction(GET_POD_VALIDITY_REMARK[SUCCESS], { response }),
  failure: (response) => createAction(GET_POD_VALIDITY_REMARK[FAILURE], { response }),
  resetPodValidityRemark: () => createAction(RESET_POD_VALIDITY_REMARK),
};

// export const submitPodFileDetails = {
//   request: (payload) => createAction(SUBMIT_POD_FILE_DETAILS[REQUEST], { payload }),
//   success: (response) => createAction(SUBMIT_POD_FILE_DETAILS[SUCCESS], { response }),
//   failure: (response) => createAction(SUBMIT_POD_FILE_DETAILS[FAILURE], { response }),
// };

export const getCancelUncancelTripReasons = {
  request: (params) => createAction(FETCH_CANCEL_UNCANCEL_TRIP_REASONS[REQUEST], { params }),
  success: (response) => createAction(FETCH_CANCEL_UNCANCEL_TRIP_REASONS[SUCCESS], { response }),
  failure: (response) => createAction(FETCH_CANCEL_UNCANCEL_TRIP_REASONS[FAILURE], { response }),
};
export const postCancelTrip = {
  request: (params) => createAction(POST_CANCEL_TRIP[REQUEST], { params }),
  success: (response) => createAction(POST_CANCEL_TRIP[SUCCESS], { response }),
  failure: (response) => createAction(POST_CANCEL_TRIP[FAILURE], { response }),
};

export const getStatesForDocket = {
  request: (params) => createAction(FETCH_STATES_FOR_DOCKET[REQUEST], { params }),
  success: (response) => createAction(FETCH_STATES_FOR_DOCKET[SUCCESS], { response }),
  failure: (response) => createAction(FETCH_STATES_FOR_DOCKET[FAILURE], { response }),
};

export const getTripMapDetails = {
  request: (params) => createAction(FETCH_TRIP_MAP_DETAILS[REQUEST], { params }),
  success: (response) => createAction(FETCH_TRIP_MAP_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(FETCH_TRIP_MAP_DETAILS[FAILURE], { response }),
};

export const getTripItinerary = {
  request: (params) => createAction(GET_TRIP_ITINERARY[REQUEST], { params }),
  success: (response) => createAction(GET_TRIP_ITINERARY[SUCCESS], { response }),
  failure: (response) => createAction(GET_TRIP_ITINERARY[FAILURE], { response }),
};

export const getDelayReasons = {
  request: (params) => {
    return createAction(GET_DELAY_REASONS[REQUEST], { params });
  },
  success: (response) => createAction(GET_DELAY_REASONS[SUCCESS], { response }),
  failure: (response) => createAction(GET_DELAY_REASONS[FAILURE], { response }),
};

export const getCancelReasons = {
  request: (params) => createAction(GET_CANCEL_REASONS[REQUEST], { params }),
  success: (response) => createAction(GET_CANCEL_REASONS[SUCCESS], { response }),
  failure: (response) => createAction(GET_CANCEL_REASONS[FAILURE], { response }),
};

export const saveDelayReason = {
  request: (payload) => createAction(SAVE_DELAY_REASON[REQUEST], { payload }),
  success: (response) => createAction(SAVE_DELAY_REASON[SUCCESS], { response }),
  failure: (response) => createAction(SAVE_DELAY_REASON[FAILURE], { response }),
};

export const saveCancelReason = {
  request: (payload) => createAction(SAVE_CANCEL_REASON[REQUEST], { payload }),
  success: (response) => createAction(SAVE_CANCEL_REASON[SUCCESS], { response }),
  failure: (response) => createAction(SAVE_CANCEL_REASON[FAILURE], { response }),
};

export const getExtraExpensePolicy = {
  request: (params) => createAction(GET_EXTRA_EXPENSE_POLICY[REQUEST], { params }),
  success: (response) => createAction(GET_EXTRA_EXPENSE_POLICY[SUCCESS], { response }),
  failure: (response) => createAction(GET_EXTRA_EXPENSE_POLICY[FAILURE], { response }),
};

export const getViewImageUrl = {
  request: (params) => createAction(GET_IMAGE_URL[REQUEST], { params }),
  success: (response) => createAction(GET_IMAGE_URL[SUCCESS], { response }),
  failure: (response) => createAction(GET_IMAGE_URL[FAILURE], { response }),
};

export const updateReferenceId = {
  request: (params) => createAction(UPDATE_REFERENCE_ID[REQUEST], { params }),
  success: (response) => createAction(UPDATE_REFERENCE_ID[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_REFERENCE_ID[FAILURE], { response }),
};

export const triggerConsignerForBilti = {
  request: (params) => createAction(TRIGGER_CONSIGNER_FOR_BILTI[REQUEST], { params }),
};

export const submitDocketImages = {
  request: (params) => createAction(SUBMIT_DOCKET_IMAGES[REQUEST], { params }),
  success: (params) => createAction(SUBMIT_DOCKET_IMAGES[SUCCESS], { params }),
  failure: (params) => createAction(SUBMIT_DOCKET_IMAGES[FAILURE], { params }),
};

export const getImageProofDocketDetails = {
  request: (params) => createAction(GET_IMAGE_PROOF_DOCKET_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_IMAGE_PROOF_DOCKET_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_IMAGE_PROOF_DOCKET_DETAILS[FAILURE], { response }),
};

export const getDelayModalData = {
  request: (params) => createAction(GET_DELAY_MODAL_DATA[REQUEST], { params }),
  success: (response) => createAction(GET_DELAY_MODAL_DATA[SUCCESS], { response }),
  failure: (response) => createAction(GET_DELAY_MODAL_DATA[FAILURE], { response }),
};
export const resetDelayModal = {
  reset: () => createAction(RESET_GET_DELAY_MODAL_DATA[RESET]),
};

export const submitDelayModal = {
  request: (params) => createAction(SUBMIT_DELAY_MODAL[REQUEST], { params }),
  success: (params) => createAction(SUBMIT_DELAY_MODAL[SUCCESS], { params }),
  failure: (params) => createAction(SUBMIT_DELAY_MODAL[FAILURE], { params }),
};

export const generateEwayBillNumber = {
  request: (params) => createAction(GENERATE_EWAY_BILL_NUMBER[REQUEST], { params }),
  success: (response) => createAction(GENERATE_EWAY_BILL_NUMBER[SUCCESS], { response }),
  failure: (response) => createAction(GENERATE_EWAY_BILL_NUMBER[FAILURE], { response }),
};
